module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"no-data":"Данные отсутствуют"},"en":{"no-data":"No data"}}')
  delete Component.options._Ctor
}
